import { createContext, useContext } from 'react'

import type { ContentPerilakuKerja } from 'types/kinerja'
import type {
  KinerjaKsKepemimpinanSatuanPendidikan,
  KinerjaKsRencanaHasilKerjaExtra,
  KinerjaKsUtamaDetail,
} from 'types/kinerja-ks'

export const ContentContext = createContext<{
  contentKepemimpinanSatuanPendidikan: Array<KinerjaKsKepemimpinanSatuanPendidikan>
  contentPengembanganKompetensi: Array<KinerjaKsUtamaDetail>
  contentRencanaHasilKerjaEkstra: Array<KinerjaKsRencanaHasilKerjaExtra>
  contentPerilakuKerja?: ContentPerilakuKerja
  getKepemimpinanSatuanPendidikanById?: (
    id: KinerjaKsKepemimpinanSatuanPendidikan['id']
  ) => KinerjaKsKepemimpinanSatuanPendidikan
  getPengembanganKompetensiById?: (
    id: KinerjaKsUtamaDetail['id']
  ) => KinerjaKsUtamaDetail
}>({
  contentKepemimpinanSatuanPendidikan: [],
  contentPengembanganKompetensi: [],
  contentRencanaHasilKerjaEkstra: [],
})

export default function useContentContext() {
  return useContext(ContentContext)
}
